import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import { EnergyTypesResponse } from '../types/eecs-common.types';

export const eecsCommonApi = createApi({
  reducerPath: 'eecsCommonApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin`),
  endpoints: (builder) => ({
    getEnergyTypes: builder.query<ApiResponse<EnergyTypesResponse>, void>({
      query: () => ({
        url: `/necs/energy-types`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyGetEnergyTypesQuery } = eecsCommonApi;
